import setValuesForPkFields from './SetValuesForPkFields'

export default (form) => {
  for (let f in form) {
    if (typeof form[f] !== 'boolean' && (!form[f] || form[f] === '')) {
      delete form[f]
    }
  }
  form = setValuesForPkFields(form)
  return form
}
